var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmeSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3160_3014)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5445 17.7149C34.543 17.3953 34.4473 17.0833 34.2694 16.8179C34.0915 16.5524 33.8392 16.3454 33.5442 16.2226C33.3481 16.1397 33.1374 16.0971 32.9245 16.0972H28.6076C28.3835 16.0782 28.1579 16.106 27.9451 16.1787C27.7322 16.2515 27.5368 16.3676 27.3712 16.5198C27.2056 16.6719 27.0734 16.8568 26.983 17.0628C26.8925 17.2687 26.8458 17.4911 26.8458 17.7161C26.8458 17.941 26.8925 18.1634 26.983 18.3694C27.0734 18.5753 27.2056 18.7602 27.3712 18.9124C27.5368 19.0645 27.7322 19.1807 27.9451 19.2534C28.1579 19.3261 28.3835 19.3539 28.6076 19.3349H29.0115L24.1028 24.2413L21.7447 20.7042C21.6113 20.5059 21.4358 20.3395 21.2306 20.2168C21.0255 20.0941 20.7958 20.0182 20.558 19.9945C20.3201 19.9707 20.08 19.9998 19.8546 20.0796C19.6293 20.1593 19.4244 20.2878 19.2544 20.4559L12.3497 27.3652C12.178 27.5102 12.0383 27.6893 11.9393 27.8911C11.8404 28.093 11.7844 28.3131 11.7749 28.5377C11.7654 28.7623 11.8026 28.9864 11.8842 29.1958C11.9657 29.4053 12.0898 29.5955 12.2487 29.7545C12.4076 29.9135 12.5977 30.0379 12.807 30.1196C13.0164 30.2014 13.2405 30.2388 13.4651 30.2296C13.6896 30.2203 13.9098 30.1645 14.1118 30.0658C14.3137 29.9671 14.4929 29.8275 14.6381 29.6559L20.1526 24.1438L22.5129 27.6832C22.6462 27.8822 22.8219 28.0493 23.0273 28.1724C23.2328 28.2956 23.4629 28.3719 23.7012 28.3957C23.9396 28.4217 24.1807 28.3934 24.4066 28.313C24.6325 28.2326 24.8372 28.1022 25.0056 27.9315L31.3091 21.6279V22.0364C31.3091 22.4673 31.4803 22.8805 31.785 23.1852C32.0897 23.4899 32.5029 23.661 32.9338 23.661C33.3647 23.661 33.7779 23.4899 34.0826 23.1852C34.3872 22.8805 34.5584 22.4673 34.5584 22.0364L34.5445 17.7149Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3160_3014",
    x1: 0,
    y1: 23.209,
    x2: 46.418,
    y2: 23.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16B0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E5AF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmeSaved);
export default __webpack_public_path__ + "static/media/TmeSaved.545231f6d8547538ea69c88d938d1b53.svg";
export { ForwardRef as ReactComponent };